@if (service.vm(); as vm) {
  <div class="tt-tree">
    @if (vm.waitForData) {
      <div class="tt-tree_overlay">
        <tt-spinner />
      </div>
    }

    @if (showAllButton) {
      <div class="tt-tree_node" [class.tt-tree_node--selected]="!service.selected().length" (click)="selectAndEmitNodes(null)">
        <div class="tt-tree_node-content" data-testid="tree_node-all">
          <div class="tt-tree_node-title">
            <span class="tt-tree_node-expand-icon-placeholder"></span>
            {{ 'Tree.All' | transloco }}
          </div>
          @if (!_readonly && !currentlyEditedNode) {
            <div class="tt-tree_node-actions">
              <button
                class="tt-tree_node-actions-item"
                data-testid="tree_all_add-node-button"
                [size]="'icon'"
                [variant]="'transparent'"
                (click)="addNode(null, $event)">
                <mat-icon [icon]="'plus'" [iconSize]="14" [ttTooltip]="'Tree.AddNode' | transloco" />
              </button>
            </div>
          }
        </div>
      </div>
    }

    <cdk-tree [dataSource]="vm.dataSource" [trackBy]="trackByFn" [treeControl]="treeControl">
      <cdk-tree-node
        *cdkTreeNodeDef="let node"
        class="tt-tree_node"
        [attr.data-testid]="'tree_node-' + node.node.id"
        [class.tt-tree_node--active]="node.node.id === activeNodeId"
        [class.tt-tree_node--disabled]="node.disabled"
        [class.tt-tree_node--selected]="node.selected"
        [style]="'--tt-tree-node-level: ' + node.level"
        [style.display]="shouldRender(node, vm.dataSource) ? 'flex' : 'none'"
        [ttTreeDragDrop]="!_readonly && node"
        [ttTreeId]="ttTreeId"
        (elementDropped)="onElementDropped($event, node)"
        (treeNodeDropped)="onTreeNodeDropped($event.node, $event.target, $event.instruction)">
        @if (currentlyEditedNode?.id === node.node.id) {
          <ng-container *ngTemplateOutlet="editNodeTemplate" />
        } @else {
          @if (dragService.targetNode() === node) {
            <tt-tree-drag-drop-indicator [instruction]="dragService.instruction()" />
          }

          <div class="tt-tree_node-content" [attr.data-testid]="'tree_node-' + node.node.id">
            @if (showDot) {
              <mat-icon
                class="tt-tree_node-dot-icon"
                [attr.aria-label]="'Toggle ' + node.node.title"
                [class.tt-tree_node-expand-icon--readonly]="_readonly"
                [icon]="'dot'"
                [iconSize]="18"
                (click)="selectAndEmitNodes(node)" />
            }

            @if (node.node.isHomeNode) {
              <mat-icon
                class="tt-tree_node-home-icon"
                [attr.aria-label]="'Home node: ' + node.node.title"
                [icon]="'home'"
                [iconSize]="16" />
            } @else if (node.node.nodeType === TableOfContentNodeType.Organisation) {
              <mat-icon
                class="tt-tree_node-organisation-icon"
                [attr.aria-label]="'Organisation node: ' + node.node.title"
                [icon]="'building'"
                [iconSize]="16" />
            }

            <div class="tt-tree_node-title" [ttTooltip]="node.node.title" [ttTooltipDelay]="2000" (click)="selectAndEmitNodes(node)">
              @if (nodeTemplate()) {
                <ng-container
                  *ngTemplateOutlet="nodeTemplate(); context: { $implicit: node.node, selected: node.selected, level: node.level }" />
              } @else {
                @if (node.node.no) {
                  @if (!showDot) {
                    <span class="tt-tree_node-expand-icon-placeholder"></span>
                  }
                  <span class="tt-tree_node-number">{{ node.node.no }}.&nbsp;</span>
                }
                <span class="tt-tree_node-title-text">{{ node.node.title }}</span>
              }
            </div>
            @if (!currentlyEditedNode && !dragService.dragNode() && !_readonly) {
              <div class="tt-tree_node-actions">
                <button
                  class="tt-tree_node-actions-item"
                  [attr.data-testid]="'tree_node-actions_context-menu-button-' + node.node.id"
                  [size]="'icon'"
                  [ttMenuTriggerFor]="menu"
                  [variant]="'transparent'">
                  <mat-icon [icon]="'three-dots-horizontal'" [iconSize]="16" />
                </button>
                @if (node.level < maxDepth - 1) {
                  <button
                    class="tt-tree_node-actions-item"
                    [attr.data-testid]="'tree_node-actions_add-node-button-' + node.node.id"
                    [size]="'icon'"
                    [variant]="'transparent'"
                    (click)="handleNewNodeButtonClick(node, $event)">
                    <mat-icon [icon]="'plus'" [iconSize]="14" [ttTooltip]="'Tree.AddNode' | transloco" />
                  </button>
                }
              </div>
              <tt-menu #menu>
                <button ttMenuItem [attr.data-testid]="'tree_context-menu_delete-node-button-' + node.node.id" (click)="removeNode(node)">
                  <mat-icon [icon]="'trash'" [iconSize]="14" />
                  {{ 'Tree.Delete' | transloco }}
                </button>
                <button ttMenuItem [attr.data-testid]="'tree_context-menu_rename-node-button-' + node.node.id" (click)="editNode(node)">
                  <mat-icon [icon]="'pencil'" [iconSize]="14" />
                  {{ 'Tree.Rename' | transloco }}
                </button>
              </tt-menu>
            }
          </div>
        }
      </cdk-tree-node>

      <cdk-tree-node
        *cdkTreeNodeDef="let node; when: hasChild"
        class="tt-tree_node"
        [attr.data-testid]="'tree_node-' + node.node.id"
        [class.tt-tree_node--active]="node.node.id === activeNodeId"
        [class.tt-tree_node--selected]="node.selected"
        [style]="'--tt-tree-node-level: ' + node.level"
        [style.display]="shouldRender(node, vm.dataSource) ? 'flex' : 'none'"
        [ttTreeDragDrop]="!_readonly && node"
        [ttTreeId]="ttTreeId"
        (elementDropped)="onElementDropped($event, node)"
        (treeNodeDropped)="onTreeNodeDropped($event.node, $event.target, $event.instruction)">
        @if (currentlyEditedNode?.id === node.node.id) {
          <ng-container *ngTemplateOutlet="editNodeTemplate" />
        } @else {
          @if (dragService.targetNode() === node) {
            <tt-tree-drag-drop-indicator [instruction]="dragService.instruction()" />
          }

          <div class="tt-tree_node-content">
            @if (showExpandToggle) {
              <mat-icon
                class="tt-tree_node-expand-icon"
                [attr.aria-label]="'Toggle ' + node.node.title"
                [class.tt-tree_node-expand-icon--expanded]="node.isExpanded"
                [class.tt-tree_node-expand-icon--readonly]="_readonly"
                [icon]="'chevron-down'"
                [iconSize]="18"
                (click)="toggleExpandNode(node, $event)" />
            }

            @if (node.node.isHomeNode) {
              <mat-icon
                class="tt-tree_node-home-icon"
                [attr.aria-label]="'Home node: ' + node.node.title"
                [icon]="'home'"
                [iconSize]="16" />
            } @else if (node.node.nodeType === TableOfContentNodeType.Organisation) {
              <mat-icon
                class="tt-tree_node-organisation-icon"
                [attr.aria-label]="'Organisation node: ' + node.node.title"
                [icon]="'building'"
                [iconSize]="16" />
            }

            <div class="tt-tree_node-title" [ttTooltip]="node.node.title" [ttTooltipDelay]="2000" (click)="selectAndEmitNodes(node)">
              @if (nodeTemplate()) {
                <ng-container
                  *ngTemplateOutlet="nodeTemplate(); context: { $implicit: node.node, selected: node.selected, level: node.level }" />
              } @else {
                @if (node.node.no) {
                  @if (!showExpandToggle) {
                    <span class="tt-tree_node-expand-icon-placeholder"></span>
                  }
                  <span class="tt-tree_node-number">{{ node.node.no }}.&nbsp;</span>
                }
                <span class="tt-tree_node-title-text">{{ node.node.title }}</span>
              }
            </div>
            @if (!currentlyEditedNode && !dragService.dragNode() && !_readonly) {
              <div class="tt-tree_node-actions" [draggable]="true" (dragstart)="$event.stopPropagation()">
                <button
                  class="tt-tree_node-actions-item"
                  [attr.data-testid]="'tree_node-actions_context-menu-button-' + node.node.id"
                  [size]="'icon'"
                  [ttMenuTriggerFor]="menu"
                  [variant]="'transparent'">
                  <mat-icon [icon]="'three-dots-horizontal'" [iconSize]="16" />
                </button>
                @if (node.level < maxDepth - 1) {
                  <button
                    class="tt-tree_node-actions-item"
                    [attr.data-testid]="'tree_node-actions_add-node-button-' + node.node.id"
                    [size]="'icon'"
                    [variant]="'transparent'"
                    (click)="handleNewNodeButtonClick(node, $event)">
                    <mat-icon [icon]="'plus'" [iconSize]="14" [ttTooltip]="'Tree.AddNode' | transloco" />
                  </button>
                }
              </div>
              <tt-menu #menu>
                <button ttMenuItem [attr.data-testid]="'tree_context-menu_delete-node-button-' + node.node.id" (click)="removeNode(node)">
                  <mat-icon [icon]="'trash'" [iconSize]="14" />
                  {{ 'Tree.Delete' | transloco }}
                </button>
                <button ttMenuItem [attr.data-testid]="'tree_context-menu_rename-node-button-' + node.node.id" (click)="editNode(node)">
                  <mat-icon [icon]="'pencil'" [iconSize]="14" />
                  {{ 'Tree.Rename' | transloco }}
                </button>
              </tt-menu>
            }
          </div>
        }
      </cdk-tree-node>
    </cdk-tree>
  </div>

  @if (!currentlyEditedNode && !_readonly && showAddButton) {
    <button
      class="tt-tree_add-node-button"
      data-testid="tree_main_add-node-button"
      ttButton
      [variant]="'transparent'"
      (click)="handleNewNodeButtonClick(null, $event)">
      <mat-icon [icon]="'plus'" [iconSize]="14" />
      {{ 'Tree.AddNodeButton' | transloco }}
    </button>
  }

  <ng-template #editNodeTemplate>
    <span class="tt-tree_edit-node" ttInput>
      <input required [(ngModel)]="temporaryName" (keyup)="handleInput($event)" />
      <mat-icon
        class="tt-tree_edit-node-action"
        data-testid="tree_node-edit_cancel-button"
        ttInputSuffix
        [icon]="'x'"
        [iconSize]="16"
        (click)="cancelEditNode()" />
      @if (temporaryName) {
        <mat-icon
          class="tt-tree_edit-node-action"
          data-testid="tree_node-edit_confirm-button"
          ttInputSuffix
          [icon]="'check'"
          [iconSize]="16"
          (click)="finalizeEditedNode()" />
      }
    </span>
  </ng-template>
}

<ng-template #addNewNodeMenu>
  <div class="tt-tree_add-node-menu">
    @for (option of addNodeOptions; track option.label) {
      <button ttMenuItem (click)="addNewNodePopoverRef.close(option.value)">{{ option.label | transloco }}</button>
    }
  </div>
</ng-template>
